module.exports = __webpack_public_path__ + "static/media/login.85a2c0cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/login.svg
// module id = 823
// module chunks = 0